import React, { useEffect } from "react";
import { Loading } from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchStoreShiftOpenStatus,
  selectShiftOpenStatusDate,
  selectShiftOpenStatusError,
  selectShiftOpenStatusLoadStatus,
  selectShiftOpenStatusRows,
} from "../features/stores/storesSlice";
import "./StoresPage.css";

function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("ru-RU");
}

export default function StoreShiftStatusPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const date = useSelector(selectShiftOpenStatusDate);
  const rows = useSelector(selectShiftOpenStatusRows);
  const loadStatus = useSelector(selectShiftOpenStatusLoadStatus);
  const error = useSelector(selectShiftOpenStatusError);

  useEffect(() => {
    dispatch(fetchStoreShiftOpenStatus());
  }, [dispatch]);

  return (
    <div className="stores-page">
      <div className="header">
        <div>
          <div className="title">Смены по магазинам</div>
          <div className="sub-title">
            Статус открытой смены на сегодня по каждому магазину. Доступно руководителям и директорам.
            {date ? ` Дата: ${date}.` : ""}
          </div>
        </div>
        <div className="header-actions">
          <button type="button" className="btn" onClick={() => dispatch(fetchStoreShiftOpenStatus())}>
            Обновить
          </button>
        </div>
      </div>

      {loadStatus === "loading" && <Loading text="Загрузка…" />}
      {loadStatus === "failed" && error && <div className="error">{error}</div>}

      {loadStatus === "succeeded" && (
        <div className="body">
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th className="th">Магазин</th>
                  <th className="th">Адрес</th>
                  <th className="th">Активен</th>
                  <th className="th">Смена</th>
                  <th className="th">Открытые смены</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="td-muted">
                      Нет магазинов
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => (
                    <tr
                      key={row.id}
                      className="tr tr-clickable"
                      title="Открыть продажи магазина"
                      onClick={() =>
                        navigate(`/warehouse/stores/${row.id}/sales`, {
                          state: { from: location.pathname + location.search },
                        })
                      }
                    >
                      <td className="td-mono">{row.name}</td>
                      <td className="td">{row.address || "—"}</td>
                      <td className="td">
                        <span className={`badge ${row.is_active ? "badge-active" : "badge-inactive"}`}>
                          {row.is_active ? "Да" : "Нет"}
                        </span>
                      </td>
                      <td className="td">
                        <span
                          className="badge"
                          style={{
                            fontWeight: 800,
                            borderColor: row.shift_open ? "var(--c-success)" : "var(--c-danger)",
                            color: row.shift_open ? "var(--c-success)" : "var(--c-danger)",
                            background: row.shift_open ? "var(--c-success-dim)" : "var(--c-danger-dim)",
                          }}
                        >
                          {row.shift_open ? "Открыта" : "Нет"}
                        </span>
                      </td>
                      <td className="td-mono" style={{ fontSize: 14, lineHeight: 1.45 }}>
                        {(row.open_shifts || []).length === 0
                          ? "—"
                          : (row.open_shifts || []).map((s) => (
                              <div key={s.shift_id}>
                                #{s.shift_id} · {s.cashier_username || "—"} · {formatDateTime(s.opened_at)}
                              </div>
                            ))}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
